/**
 * Rating field (form_attribute_type_id 17).
 *
 * The number of stars a visitor sees is stored on the attribute config as
 * `max`, next to the other per-type settings (file `max`, audio `maxDuration`).
 * A field saved before this setting existed has no `max` and falls back to the
 * historical 5 stars.
 */
export const DEFAULT_RATING_MAX = 5

export const MIN_RATING_MAX = 2
export const MAX_RATING_MAX = 10

/**
 * Turns whatever sits in `config.max` into a usable star count: a partial
 * entry ('', '1', 42, null) never renders a broken scale.
 */
export function clampRatingMax(value) {
    const parsed = Number.parseInt(value, 10)
    if (!Number.isFinite(parsed)) return DEFAULT_RATING_MAX
    return Math.min(Math.max(parsed, MIN_RATING_MAX), MAX_RATING_MAX)
}

/**
 * Reads the star count off an attribute config, which reaches the UI either as
 * an object (form builder, wizard) or as a JSON string (post answers payload).
 */
export function readRatingMax(config) {
    let parsed = config

    if (typeof parsed === 'string') {
        try {
            parsed = JSON.parse(parsed)
        } catch (e) {
            return DEFAULT_RATING_MAX
        }
    }

    if (!parsed || typeof parsed !== 'object') return DEFAULT_RATING_MAX

    return clampRatingMax(parsed.max)
}

/**
 * Score actually given, kept inside the scale: an answer recorded on a wider
 * scale than the one configured today must not draw more stars than there are.
 */
export function clampRatingScore(value, max) {
    const parsed = Number.parseInt(value, 10)
    if (!Number.isFinite(parsed) || parsed < 0) return 0
    return Math.min(parsed, max)
}
